import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { updateAuth } from "Redux/Actions/authActions";
import { updateMenu } from "Redux/Actions/menuActions";
import { connect } from "react-redux";
import { Divider } from "primereact/divider";
import laurier_gris from "assets/laurier_gris.webp";
import { findItemInEditManagementVisibility } from "Services/functions";

/**
 * Construit les menus déroulant de la barre de navigation sur desktop
 */
const MenuDepliant = (props) => {
  return (
    <div>
      {props.item == "event" && (
        <ul>
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemEvenement: props.items.itemsEvenement.findIndex(
                  (v) => v.label == "Tous les événements"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              {/* c'est ici que apparaît l'erreur de validate DOM  */}
              <Link to="/evenements">Tous les événements</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemEvenement: props.items.itemsEvenement.findIndex(
                  (v) => v.label == "Proposer un événement"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/evenements" className="alumni">
                Proposer un événement
              </Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemEvenement: props.items.itemsEvenement.findIndex(
                  (v) => v.label == "Gérer mes événements"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/evenements">Gérer mes événements</Link>
            </div>
          </li>
        </ul>
      )}
      {props.item == "eventadmin" && (
        <ul>
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemEvenementAdmin:
                  props.items.itemsEvenementAdmin.findIndex(
                    (v) => v.label == "Tous les événements"
                  ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/evenements">Tous les événements</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemEvenementAdmin:
                  props.items.itemsEvenementAdmin.findIndex(
                    (v) => v.label == "Créer un événement"
                  ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/evenements" className="alumni">
                Créer un événement
              </Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemEvenementAdmin:
                  props.items.itemsEvenementAdmin.findIndex(
                    (v) => v.label == "Gérer les événements"
                  ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/evenements">Gérer les événements</Link>
            </div>
          </li>
        </ul>
      )}
      {props.item == "actu" && (
        <ul>
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemActu: props.items.itemsActu.findIndex(
                  (v) => v.label == "Toutes les actus"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/actualites">Toutes les actus</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemActu: props.items.itemsActu.findIndex(
                  (v) => v.label == "Proposer une actu"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/actualites">Proposer une actu</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemActu: props.items.itemsActu.findIndex(
                  (v) => v.label == "Gérer mes actus"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/actualites">Gérer mes actus</Link>
            </div>
          </li>
        </ul>
      )}
      {props.item == "actuadmin" && (
        <ul>
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemActuAdmin: props.items.itemsActuAdmin.findIndex(
                  (v) => v.label == "Toutes les actus/conseils"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/actualites">Toutes les actus/conseils</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemActuAdmin: props.items.itemsActuAdmin.findIndex(
                  (v) => v.label == "Créer une actu/conseil"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/actualites">Créer une actu/conseil</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemActuAdmin: props.items.itemsActuAdmin.findIndex(
                  (v) => v.label == "Gérer les actus/conseils"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/actualites">Gérer les actus/conseils</Link>
            </div>
          </li>
        </ul>
      )}
      {props.item == "offres" && (
        <ul>
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemOffre: props.items.itemsOffre.findIndex(
                  (v) => v.label == "Trouver une offre"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/offres">Trouver une offre</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemOffre: props.items.itemsOffre.findIndex(
                  (v) => v.label == "Déposer une offre"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/offres">Déposer une offre</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemOffre: props.items.itemsOffre.findIndex(
                  (v) => v.label == "Gérer mes dépôts d'offres"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/offres">
                {props.auth.isAdmin
                  ? "Gérer les dépôts d'offres"
                  : "Gérer mes dépôts d'offres"}
              </Link>
            </div>
          </li>
        </ul>
      )}
      {props.item == "groupe" && (
        <ul>
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemGroupes: props.items.itemsGroupes.findIndex(
                  (v) => v.label == "Mes groupes d'échanges"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/groupes">Mes groupes d&apos;échanges</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemGroupes: props.items.itemsGroupes.findIndex(
                  (v) => v.label == "Trouver un groupe"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/groupes">Trouver un groupe</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemGroupes: props.items.itemsGroupes.findIndex(
                  (v) => v.label == "Événements de groupe"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/groupes">Événements de groupe</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemGroupes: props.items.itemsGroupes.findIndex(
                  (v) => v.label == "Proposer et gérer mes groupes"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/groupes">Proposer et gérer mes groupes</Link>
            </div>
          </li>
        </ul>
      )}
      {props.item == "groupeadmin" && (
        <ul>
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemGroupesAdmin: props.items.itemsGroupesAdmin.findIndex(
                  (v) => v.label == "Mes groupes d'échanges"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/groupes">Mes groupes d&apos;échanges</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemGroupesAdmin: props.items.itemsGroupesAdmin.findIndex(
                  (v) => v.label == "Trouver un groupe"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/groupes">Trouver un groupe</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemGroupesAdmin: props.items.itemsGroupesAdmin.findIndex(
                  (v) => v.label == "Événements de groupe"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/groupes">Événements de groupe</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemGroupesAdmin: props.items.itemsGroupesAdmin.findIndex(
                  (v) => v.label == "Créer et gérer mes groupes"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/groupes">Créer et gérer mes groupes</Link>
            </div>
          </li>
        </ul>
      )}
      {props.item == "cvtheque" && (
        <ul>
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemCVTheque: props.items.itemsCVTheque.findIndex(
                  (v) => v.label == "Cv thèque"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/cvtheque">Cv thèque</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemCVTheque: props.items.itemsCVTheque.findIndex(
                  (v) => v.label == "Cv sauvegardés"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/cvtheque">Cv sauvegardés</Link>
            </div>
          </li>
          {props.auth.isAdmin && (
            <>
              <Divider />

              <li
                onClick={(event) => {
                  event.stopPropagation();
                  props.handleMenu({
                    activeItemCVTheque: props.items.itemsCVTheque.findIndex(
                      (v) => v.label == "Paniers de cv"
                    ),
                  });
                }}
              >
                <div className="annuaireBox">
                  <Link to="/cvtheque">Paniers de cv</Link>
                </div>
              </li>
            </>
          )}
        </ul>
      )}
      {props.item == "annuaire" && (
        <ul>
          {findItemInEditManagementVisibility(
            "visibleAnnuaireEtudiant",
            props.admin.editManagementBoolean
          ) && (
            <>
              <li
                onClick={(event) => {
                  event.stopPropagation();
                  props.handleMenu({
                    activeItemAnnuaire: props.items.itemsAnnuaire.find(
                      (v) => v.label == "Annuaire étudiants"
                    ),
                  });
                }}
              >
                <div className="annuaireBox">
                  <i className="pi pi-user" style={{ fontSize: "1.2rem" }}>
                    {" "}
                  </i>
                  <Link to="/annuaire">Annuaire étudiants</Link>
                </div>
              </li>
              <Divider />
            </>
          )}
          {findItemInEditManagementVisibility(
            "visibleAnnuaireAlumni",
            props.admin.editManagementBoolean
          ) && (
            <>
              <li
                onClick={(event) => {
                  event.stopPropagation();
                  props.handleMenu({
                    activeItemAnnuaire: props.items.itemsAnnuaire.find(
                      (v) => v.label == "Annuaire Alumni"
                    ),
                  });
                }}
              >
                <div className="annuaireBox">
                  <img
                    src={laurier_gris}
                    className="laurier"
                    alt="Laurier alumni"
                    title="Laurier alumni"
                  />
                  <i className="pi pi-star" style={{ fontSize: "1.2rem" }}>
                    {" "}
                  </i>
                  <Link to="/annuaire" className="alumni">
                    Annuaire Alumni
                  </Link>
                </div>
              </li>
              <Divider />
            </>
          )}
          {findItemInEditManagementVisibility(
            "visibleAnnuaireEntreprise",
            props.admin.editManagementBoolean
          ) && (
            <li
              onClick={(event) => {
                event.stopPropagation();
                props.handleMenu({
                  activeItemAnnuaire: props.items.itemsAnnuaire.find(
                    (v) => v.label == "Annuaire entreprises"
                  ),
                });
              }}
            >
              <div className="annuaireBox">
                <i
                  className="pi pi-building"
                  style={{ fontSize: "1.2rem" }}
                ></i>
                <Link to="/annuaire">Annuaire entreprises</Link>
              </div>
            </li>
          )}
        </ul>
      )}
      {props.item == "parametres" && (
        <ul>
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemParametrage: props.items.itemsParametrage.findIndex(
                  (v) => v.label == "Requêtes et exports"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/parametrage">Requêtes et exports</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemParametrage: props.items.itemsParametrage.findIndex(
                  (v) => v.label == "Gestion des droits"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/parametrage">Gestion des droits</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemParametrage: props.items.itemsParametrage.findIndex(
                  (v) => v.label == "Gestion des adhésions"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/parametrage">Gestion des adhésions</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemParametrage: props.items.itemsParametrage.findIndex(
                  (v) => v.label == "Gestion éditoriale"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/parametrage">Gestion éditoriale</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemParametrage: props.items.itemsParametrage.findIndex(
                  (v) => v.label == "Paramètres du site"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/parametrage">Paramètres du site</Link>
            </div>
          </li>
          <Divider />
          <li
            onClick={(event) => {
              event.stopPropagation();
              props.handleMenu({
                activeItemParametrage: props.items.itemsParametrage.findIndex(
                  (v) => v.label == "Statistiques"
                ),
              });
            }}
          >
            <div className="annuaireBox">
              <Link to="/parametrage">Statistiques</Link>
            </div>
          </li>
        </ul>
      )}
    </div>
  );
};

MenuDepliant.propTypes = {
  menuNotConnected: PropTypes.any,
  role: PropTypes.string,
  item: PropTypes.string,
  navbarOpen: PropTypes.bool,
  handleToggle: PropTypes.func,
  auth: PropTypes.object,
  handleAuth: PropTypes.func,
  handleMenu: PropTypes.func,
  items: PropTypes.object,
  admin: PropTypes.object,
  annuaire: PropTypes.number,
  activeIndex: PropTypes.number,
  setActiveIndex: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  admin: state.admin,
});

const mapDispatchToProps = (dispatch) => ({
  handleAuth: (value) => {
    dispatch(updateAuth(value));
  },
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuDepliant);
